import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PricingItemDto } from '../../../shared/modules/pricing-items/dtos/pricing-item.dto';
import { ComputedPeriodDurationDto } from '../../../shared/modules/shared/dtos/computed-period-duration.dto';
import { CheckInDto } from '../../check-ins/dtos/check-in.dto';
import { CheckOutDto } from '../../check-outs/dtos/check-out.dto';
import { SupplierSearchDto } from '../../suppliers/dtos/supplier-search.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleSearchDto } from '../../vehicles';
import { VehicleMaintenanceRecordCategoryEnum } from '../enums/vehicle-maintenance-record-category.enum';
import { VehicleMaintenanceStatusEnum } from '../enums/vehicle-maintenance-status.enum';

import { VehicleMaintenanceLinksDto } from './vehicle-maintenance-links.dto';

/**
 * Vehicle maintenance record DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE_MAINTENANCE)
export class VehicleMaintenanceRecordDto extends BaseDto {
  code!: string;
  documentNumber!: string;
  externalReference?: string | null;
  recordCategory!: VehicleMaintenanceRecordCategoryEnum;
  status!: VehicleMaintenanceStatusEnum;
  notes?: string | null;
  startsAt?: Date | null;
  endsAt?: Date | null;
  estimatedCost?: number | null;
  serviceCenter?: string | null;
  description?: string | null;
  vehicleId?: number | null;
  vehicle?: VehicleSearchDto | null;
  supplierId?: number | null;
  supplier?: SupplierSearchDto | null;
  rentalAgreementId?: number | null;
  vehicleRoadWorthyCheckId?: number | null;
  vehicleDamageId?: number | null;
  checkOuts?: CheckOutDto[] | null;
  checkIns?: CheckInDto[] | null;
  pricingItems?: PricingItemDto[] | null;
  computedPeriod?: ComputedPeriodDurationDto | null;
  computedTotalNet?: number | null;
  computedTotalTax?: number | null;
  computedTotalGross?: number | null;
  tags?: TagListDto[] | null;
  links?: VehicleMaintenanceLinksDto | null;
  files?: FileDto[] | null;
}
